import { Component, OnInit } from '@angular/core';
import { RouteInfo } from '../../interfaces/route-info.interface';
import { AuthService } from '../../services/auth/auth.service';
import packageInfo from '../../../../package.json';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Inicio',
    icon: 'space_dashboard',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/stats',
    title: 'Estadísticas',
    icon: 'query_stats',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/appointments',
    title: 'Citas',
    icon: 'event',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/patients',
    title: 'Pacientes',
    icon: 'groups',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/recalls',
    title: 'Recalls',
    icon: 'notifications_active',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/feedback',
    title: 'Encuestas y reseñas',
    icon: 'reviews',
    class: '',
    roles: ['Admin', 'Coordinadora'],
  },
  {
    path: '/fichajes',
    title: 'Fichajes',
    icon: 'badge',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar'],
  },
  {
    path: '/templates',
    title: 'Plantillas',
    icon: 'description',
    class: '',
    roles: ['Coordinadora', 'MetaReviewer'],
  },
  {
    path: '/whatsapp',
    title: 'WhatsApp',
    icon: 'forum',
    class: '',
    roles: ['Admin', 'Coordinadora', 'Auxiliar', 'MetaReviewer'],
  },
  {
    path: '/config/whatsapp',
    title: 'Conexión WhatsApp',
    icon: 'link',
    class: '',
    roles: ['MetaReviewer'],
  },
  {
    path: '/config',
    title: 'Configuración',
    icon: 'settings',
    class: '',
    roles: ['Admin'],
  },

  // { path: '/user-profile', title: 'User Profile', icon: 'person', class: '' },
  // {
  //   path: '/table-list',
  //   title: 'Table List',
  //   icon: 'content_paste',
  //   class: '',
  // },
  // {
  //   path: '/typography',‚
  //   title: 'Typography',
  //   icon: 'library_books',
  //   class: '',
  // },
  // { path: '/icons', title: 'Icons', icon: 'bubble_chart', class: '' },
  // { path: '/maps', title: 'Maps', icon: 'location_on', class: '' },
  // {
  //   path: '/notifications',
  //   title: 'Notifications',
  //   icon: 'notifications',
  //   class: '',
  // },
  // {
  //   path: '/upgrade',
  //   title: 'Upgrade to PRO',
  //   icon: 'unarchive',
  //   class: 'active-pro',
  // },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  readonly appVersion = packageInfo.version;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter((menuItem) => {
      if (!menuItem.roles || menuItem.roles.length === 0) {
        return true;
      }

      return this.authService.hasRole(menuItem.roles);
    });
  }
}
